import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { useTeamsGwPromptsUpdate } from '../hooks/useTeamsGwPrompts';
import { handleSubmit } from './utils/settingsUtils';
import routerPaths from '../util/routerPaths';

export const useSettingsHandlers = (auth, promptsData) => {
  const history = useHistory();
  const {
    promptChanges,
    setPromptChanges,
    updatePromptsInfo,
    setUpdatePromptsInfo,
  } = useTeamsGwPromptsUpdate(promptsData.getPromptsInfo);
  const [errorMsg, setErrorMsg] = useState('');
  const [showProgress, setShowProgress] = useState(false);
  const [submitEnabled, setSubmitEnabled] = useState(true);

  const [policies, setPolicies] = useState(
    auth?.tenant?.settings?.devices?.policies
      ? auth?.tenant.settings.devices.policies
      : [],
  );

  useEffect(() => {
    setPolicies(auth?.tenant?.settings?.devices?.policies || []);
  }, [auth?.tenant?.settings?.devices?.policies]);

  const onSubmit = async (values, actions) => {
    await handleSubmit(
      values,
      actions,
      scroll,
      auth,
      policies,
      setErrorMsg,
      promptChanges,
      history,
      promptsData.defaultPrompts,
      setShowProgress,
      setUpdatePromptsInfo,
    );
  };

  const exit = () => {
    history.push(routerPaths.HOME);
  };

  return {
    onSubmit,
    exit,
    setPromptChanges,
    updatePromptsInfo,
    errorMsg,
    showProgress,
    submitEnabled,
    setSubmitEnabled,
    policies,
    setPolicies,
  };
};
